import { post, destroy, get } from '../util/request';

const authConfig = {
  loginPath: '/v1/users/sign_in',
  logoutPath: '/v1/users/sign_out',
  sessionPath: '/v1/session',
};

export const login = async (user) => {
  const res = await post(authConfig.loginPath, { user });
  return res.data;
};

export const logout = async () => {
  const res = await destroy(authConfig.logoutPath);
  return res.data;
};

export const fetchSession = async () => {
  const res = await get(
    authConfig.sessionPath,
    {},
    {
      maxRedirects: 0,
      headers: {
        Accept: 'application/json',
      },
    }
  );
  return res.data;
};

const Auth = { fetchSession, login, logout };

export default Auth;
